import React from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Breadcrumb,
  Loader,
  Table,
  Header,
  List,
  Popup,
  Icon,
} from "semantic-ui-react";
import { ADMIN_GET_SUBSCRIPTION } from "../../GraphQL";
import { useQuery } from "@apollo/client";

const SubscriptionAdminPage = ({ match }) => {
  const { loading, error, data } = useQuery(ADMIN_GET_SUBSCRIPTION, {
    variables: { id: match.params.id },
  });

  if (loading) {
    return <Loader active />;
  } else if (error) {
    throw error;
  }

  const { subscription } = data;

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/admin">Admin Home</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section active>{match.params.id}</Breadcrumb.Section>
      </Breadcrumb>

      <Header as="h1">Subscription {match.params.id}</Header>
      <Table definition celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell>Value</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>ID</Table.Cell>
            <Table.Cell>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://dashboard.stripe.com/subscriptions/${subscription.id}`}
              >
                {subscription.id} <Icon name="external" />
              </a>
              <Popup
                position="top center"
                content="Copied!"
                mouseLeaveDelay={500}
                on="click"
                trigger={
                  <Icon
                    onClick={() =>
                      navigator.clipboard.writeText(subscription.id)
                    }
                    name="copy"
                  />
                }
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Customer</Table.Cell>
            <Table.Cell>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://dashboard.stripe.com/customers/${subscription.customer}`}
              >
                {subscription.customer} <Icon name="external" />
              </a>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell
              negative={subscription.users.length > subscription.quantity}
            >
              Usage
            </Table.Cell>
            <Table.Cell>
              {subscription.users.length} / {subscription.quantity}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell
              negative={
                subscription.status !== "active" &&
                subscription.status !== "trialing"
              }
            >
              Status
            </Table.Cell>
            <Table.Cell>{subscription.status}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell
              negative={subscription.users.length > subscription.quantity}
            >
              Users ({subscription.users.length})
            </Table.Cell>
            <Table.Cell>
              <List>
                {subscription.users.map((u) => (
                  <List.Item key={u.sub}>
                    <Link to={`/admin/users/${u.sub}`}>{u.email}</Link>
                  </List.Item>
                ))}
              </List>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default withRouter(SubscriptionAdminPage);
